import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import FamilyConsent from "./FamilyConsent";
import { fetchFamilyPortalConsentStatus, isFamilyPortalConsentConfirmed } from "../../common/utils/familyPortalConsent";

/**
 * Wraps every family portal route. Until the server confirms the family member
 * has accepted the confidentiality agreement, only the agreement is rendered:
 * the requested page is not mounted, so none of its data APIs are called.
 */
const FamilyConsentGate = ({ children }) => {
  const [status, setStatus] = useState(() => (isFamilyPortalConsentConfirmed() ? "accepted" : "checking"));

  useEffect(() => {
    if (status !== "checking") {
      return undefined;
    }

    let cancelled = false;

    fetchFamilyPortalConsentStatus().then((accepted) => {
      if (!cancelled) {
        setStatus(accepted ? "accepted" : "required");
      }
    });

    return () => {
      cancelled = true;
    };
  }, [status]);

  if (status === "accepted") {
    return children;
  }

  if (status === "required") {
    return <FamilyConsent onAccepted={() => setStatus("accepted")} />;
  }

  return (
    <Backdrop sx={{ color: "#ffba30", zIndex: (theme) => theme.zIndex.drawer + 1000 }} open>
      <img src={require("../../assets/btTree.png")} className="loading-img" alt="" />
    </Backdrop>
  );
};

export default FamilyConsentGate;
